<template>
    <gat-form>
        <gat-group title="Filter" :collapsed=false>
            <v-layout wrap>
                <gat-edit v-model="filter.fromDate" size="s" label="From date" dateEdit=true />
                <gat-edit v-model="filter.toDate" size="s" label="To date" dateEdit=true />
                <v-btn @click="getData">Apply</v-btn>
            </v-layout>
        </gat-group>

        <gat-group title="Amounts per category" :collapsed=false>
            <amounts-per-category :value="transactions" />
        </gat-group>

        <gat-group title="Budget" :collapsed=false>
            <category-budget :transactions="transactions" :fromDate="filter.fromDate" :toDate="filter.toDate" />
        </gat-group>
    </gat-form>
</template>

<script>
    import GatGroup from '@/GatComponents/GatGroup.vue';
    import GatForm from '@/GatComponents/GatForm.vue';
    import GatEdit from '@/GatComponents/GatEdit.vue';
    import AmountsPerCategory from '@/components/AmountsPerCategory.vue';
    import CategoryBudget from '@/components/CategoryBudget.vue';
    import {apiPost} from '@/dal';
    export default {
        name: 'Report',
        props: [],
        components: {GatGroup,GatForm,GatEdit,AmountsPerCategory,CategoryBudget},
        data: function() {
            return	{               
                filter:{
                    fromDate:null,
                    toDate:null
                },
            }
        },


        created(){
          
        },

        computed:{
            transactions(){
                return this.$store.state.dashTransactions;
            }
        },

        mounted(){
            let today=new Date();
            this.filter.fromDate = new Date(today.getFullYear(),0,1);
        },

        watch:{
        },

        methods:{
            getData(){
               apiPost('db/get/transactions',{'fromDate':this.filter.fromDate,'toDate':this.filter.toDate}).then(data=>{
                   this.$store.commit('setDashTransactions',data);
               }).catch(()=>{                 
               })
            }
        },
    }
</script>

<style scoped>

</style>
